import { Model } from '@/models/Model';

export class Brand extends Model {
  protected $name: string = 'Brand';
  protected $endpoint: string = '/brands';
  protected $fillable: string[] = ['name', 'short_name', 'is_active', 'supplier', 'creditor'];

  public name?: string;
  public short_name?: string;
  public is_active?: boolean;
  public id?: string;
  public supplier?: string;
  public creditor?: string;

  protected static instance?: Brand;
  public static getInstance(instance: Brand) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
